var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Observable } from '../../Observable.js';
import { Bound } from './Bound.js';
import { DebounceHandler } from './DebounceHandler.js';
/**
 * Wraps an Observable with debounced `on_start` and `on_end` callbacks.
 */
export class DebouncedObservable {
    constructor(_viewer, _observable, config = {}) {
        this._viewer = _viewer;
        this._observable = _observable;
        this.on_start = new Observable();
        this.on_end = new Observable();
        this._observer = this._observable.add(this.call);
        const { frames_to_start, frames_to_end, debounce_time } = config;
        this._debounce_handler = new DebounceHandler(this._viewer, this.notify_start, this.notify_end, frames_to_start, frames_to_end, debounce_time);
    }
    dispose() {
        this.on_start.dispose();
        this.on_end.dispose();
        this._observer.dispose();
        this._debounce_handler.dispose();
    }
    call(sender, value) {
        this._debounce_handler.call(sender, value);
    }
    notify_start(sender, value) {
        this.on_start.notify(sender, value);
    }
    notify_end(sender, value) {
        this.on_end.notify(sender, value);
    }
}
__decorate([
    Bound
], DebouncedObservable.prototype, "call", null);
__decorate([
    Bound
], DebouncedObservable.prototype, "notify_start", null);
__decorate([
    Bound
], DebouncedObservable.prototype, "notify_end", null);
//# sourceMappingURL=DebouncedObservable.js.map